import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Paths } from '../../../navigation/paths';
import ErrorBoundary from '../../utils/error-boundary';
import NotificationsList from './notification-list';
import { FormattedMessage } from 'react-intl';

const SidebarRight = styled.div`
  flex: none;
  height: 100%;
  width: 240px;
  overflow-x: visible;
  overflow-y: auto;
  background-color: var(--matt-darker-bg-color);
`;

const Header = styled.header`
  padding: 20px 20px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const NotificationsSidebar = (): JSX.Element => {
  const history = useHistory();

  const handleAllNotificationClick = (): void => {
    history.push(Paths.notifications);
  };

  return (
    <SidebarRight>
      <ErrorBoundary>
        <Header>
          <span className="text-14">
            <b>
              <FormattedMessage id={'notificationsPage.title'} />
            </b>
          </span>
          <span className="text-12 text-gray cursor-pointer" onClick={handleAllNotificationClick}>
            <FormattedMessage id={'notificationsPage.allNotifications'} />
          </span>
        </Header>
        <NotificationsList />
      </ErrorBoundary>
    </SidebarRight>
  );
};

export default NotificationsSidebar;
